<section class="events" *ngIf="isSectionVisible">
    <div #eventsContainer class="container">
        <ng-container *ngIf="!appointmentOnly">
            <h2 class="events__title events__title--theme">{{ title }}</h2>
            <ng-container *ngIf="contentList.length > 0">
                <div class="events__para-list">
                    <p *ngFor="let content of contentList">
                        {{content}}
                    </p>
                </div>
            </ng-container>
            
            <ng-container *ngFor="let event of events">
                <app-event [event]="event"></app-event>
            </ng-container>
            <p *ngIf="appointmentsAvailable" class="events__text">
                {{ ctaAppointmentText }}
                <a class="events__link" href="#">{{ ctaAppointmentButtonText }}</a>
            </p>
        </ng-container>
        <ng-container *ngIf="appointmentOnly || events.length === 0">
            <p class="events__text">
                {{ appointmentOnlyText }}
                <a class="events__link" href="#">{{ ctaAppointmentButtonText }}</a>
            </p>
        </ng-container>
    </div>
</section>
